import ChevronDown from "../../svg/chevron-down";

interface ClickableBatchProps {
  onClick?: () => void;
  text: string;
  shouldHideBorder?: boolean;
  /** Optional custom font size for the label (e.g. "0.875rem"); falls back to the SCSS default. */
  fontSize?: string;
}

/**
 * Clickable badge control with label text and a chevron affordance.
 *
 * @param props - Display text, optional click handler, border toggle, and font size
 * @returns Clickable badge UI
 */
const ClickableBatch = (props: ClickableBatchProps) => {
  return (
    <div
      className={`clickable-batch--container ${props.shouldHideBorder ? "no-border" : ""}`.trim()}
      onClick={(e) => {
        e.stopPropagation();
        props.onClick?.();
      }}
    >
      <div className="clickable-batch--text" style={props.fontSize ? { fontSize: props.fontSize } : undefined}>
        {props.text}
      </div>
      <div className="clickable-batch--icon">
        <ChevronDown />
      </div>
    </div>
  );
};

export default ClickableBatch;
